import { render, staticRenderFns } from "./HrEmployeeContractHis.vue?vue&type=template&id=2ab31f20&scoped=true&"
import script from "./HrEmployeeContractHis.vue?vue&type=script&lang=js&"
export * from "./HrEmployeeContractHis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab31f20",
  null
  
)

export default component.exports